const AddAttrSvg = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="ag-buton"
    >
      <rect width="40" height="40" fill="#D3DEE3"></rect>
      <path
        d="M20.5 19.5V16H19.5V19.5H16V20.5H19.5V24H20.5V20.5H24V19.5H20.5Z"
        fill="#67717A"
      ></path>
    </svg>
  );
};

export default AddAttrSvg;
